import React, { useContext, useEffect, useState } from 'react';
import DataPayment from './DataPayment';
import mtn from '../../../../assets/MTN.svg';
import { getDataPlans } from '../../service/dataPlans';
import { AuthContext } from '../../../../context/authContext';
import useBuyData from './useBuyData';

const MTNDataPayment = () => {
  const { userInfo } = useContext(AuthContext);
  const { userId } = userInfo;
  const [dataPlans, setDataPlans] = useState([]);

  useEffect(() => {
    getDataPlans(userId, setDataPlans);
  }, [userId]);

  const removeWords = (word) => `${word.split(' ').slice(1, 4).join('')})`;

  const filterDataPlansithLabel = () => {
    return dataPlans
      .filter((plan) => plan.provider === 'MTN')
      .map((m) => ({ ...m, label: removeWords(m.name) }));
  };

  const {
    handleDataSubscription,
    setMobileNumber,
    mobileNumber,
    selectedOption,
    setSelectedOption,
    loading,
    success,
  } = useBuyData();

  return (
    <DataPayment
      logo={mtn}
      sucess={success}
      dataPlans={filterDataPlansithLabel()}
      selectedOption={selectedOption}
      setSelectedOption={setSelectedOption}
      setMobileNumber={setMobileNumber}
      mobileNumber={mobileNumber}
      handleDataSubscription={() => handleDataSubscription(1)}
      loading={loading}
    />
  );
};

export default MTNDataPayment;
